import { DatePresetOption } from "@/common/enums/date-preset";
export class ArrayHelper {
    /**
     * Find first instance of an item in an array based on provided predicate
     */
    static findFirstIndex(array, predicate) {
        for (let i = 0, j = array.length; i < j; i++) {
            if (predicate(array[i])) {
                return i;
            }
        }
        return -1;
    }
    ;
    /**
     * Ensure that option exists in array.
     */
    static ensureOptionExists(item, array, predicate) {
        let found = ArrayHelper.findFirstIndex(array, predicate);
        if (found >= 0)
            return;
        array.push(item);
    }
}
/**
 * Default date filters (e.g. 7 days, 1 month).
 */
ArrayHelper.defaultDateFilters = [
    {
        value: DatePresetOption.Default,
        text: "Any period"
    },
    {
        value: DatePresetOption.SevenDays,
        text: "7 days"
    },
    {
        value: DatePresetOption.OneMonth,
        text: "1 month"
    },
    {
        value: DatePresetOption.ThreeMonths,
        text: "3 months"
    },
    {
        value: DatePresetOption.OneYear,
        text: "1 year"
    },
];
